import { IRiskTolerance } from '../sp-types/accountTypes';

export type exposureType = 'minusDanger' | 'minusAlert' | 'stable' | 'plusAlert' | 'plusDanger';

export enum ExposureTypes {
  minusDanger = -2,
  minusAlert = -1,
  stable = 0,
  plusAlert = 1,
  plusDanger = 2,
}

export const getExposreDesc = (exposure: ExposureTypes): string => {
  switch (exposure) {
    case ExposureTypes.plusDanger:
    case ExposureTypes.minusDanger:
      return 'High exposure';
    case ExposureTypes.minusAlert:
    case ExposureTypes.plusAlert:
      return 'Medium exposure';
    case ExposureTypes.stable:
      return 'Stable';
    default:
      return 'none';
  }
};

export const getExposureColor = (exposure: ExposureTypes): string => {
  switch (exposure) {
    case ExposureTypes.minusDanger:
      return '#ff575e';
    case ExposureTypes.minusAlert:
      return '#ff9900';
    case ExposureTypes.stable:
      return '#00af99';
    case ExposureTypes.plusAlert:
      return '#ff9900';
    case ExposureTypes.plusDanger:
      return '#ff575e';
    default:
      return 'black'; // Default color if exposure type is unknown
  }
};

export const getExposureStatus = (riskTolerance: IRiskTolerance, amount: number): ExposureTypes => {
  if (amount < riskTolerance.dangerAreaMinus.end) {
    return ExposureTypes.minusDanger;
  }
  if (amount < riskTolerance.stableArea.start) {
    return ExposureTypes.minusAlert;
  }
  if (amount < riskTolerance.stableArea.end) {
    return ExposureTypes.stable;
  }
  if (amount < riskTolerance.dangerAreaPlus.start) {
    return ExposureTypes.plusAlert;
  }
  return ExposureTypes.plusDanger;
};
